import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestRemote } from "../../entity/EntityRequestRemote";

export class DtoRequestRemotesGetRes extends EntityRequestRemote {
  public items: EntityRequestRemote[]  = [];
}
